// iOS garde son écran de lancement natif tant que l'app n'affiche rien : il n'y a rien à rendre.
// Android a le sien dans `LaunchSplash.android.js`.
export const LaunchSplash = () => null
